<div class="update-message" *ngIf="messageInfo">
    <div>
        <img [ngClass]="toastIconCss[messageInfo.type]" [src]="toastIcon[messageInfo.type] | asset">
    </div>
    <h3 [ngClass]="'header-'+toastIconCss[messageInfo.type]">{{messageInfo?.type}}</h3>
    <div>
        {{messageInfo?.description}}
    </div>
    <div *ngIf="messageInfo?.errorCode">
        Error code: {{messageInfo?.errorCode}}
    </div>
    <space-btn variant="btn1" class="btn-ok"
        (clickEvent)="close()">{{translation['userProfile.securityPreference.okBtn']}}</space-btn>
</div>
